import { useState, useEffect } from "react";
import client from "@/lib/api";
import { usePoll } from "@/hooks/usePoll";

// Set of workerIds currently on shift / clocked in (from /attendance/live).
export function useActiveWorkers(intervalMs = 20000) {
  const [ids, setIds] = useState(() => new Set());
  const load = () => client.get("/attendance/live")
    .then((r) => setIds(new Set((r.data.staff || []).map((s) => s.workerId))))
    .catch(() => {});
  useEffect(() => { load(); }, []);
  usePoll(load, intervalMs);
  return ids;
}
